import React, { useMemo, useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { centralDbRequest, getCentralDbUrls } from '../services/centralDbClient';

const DashboardPage: React.FC = () => {
  const { accessToken } = useSelector((state: RootState) => (state as any).auth);
  const urls = useMemo(getCentralDbUrls, []);
  const [specStatus, setSpecStatus] = useState<'idle' | 'loading' | 'ok' | 'error'>('idle');
  const [specError, setSpecError] = useState<string | null>(null);

  const checkOpenApi = async () => {
    setSpecStatus('loading');
    setSpecError(null);
    try {
      const res = await centralDbRequest({ method: 'GET', path: '/openapi', token: accessToken });
      if (!res.ok) {
        throw new Error(typeof res.data === 'string' ? res.data : `HTTP ${res.status}`);
      }
      setSpecStatus('ok');
    } catch (e: any) {
      setSpecStatus('error');
      setSpecError(e?.message || 'Failed to load OpenAPI spec');
    }
  };

  return (
    <Stack spacing={2}>
      <Typography variant="h5" fontWeight={800}>
        Overview
      </Typography>

      <Card variant="outlined">
        <CardContent>
          <Stack spacing={1}>
            <Typography variant="subtitle1" fontWeight={700}>
              Central DB URLs
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Origin: {urls.origin}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              API Base: {urls.apiBaseUrl}
            </Typography>
            <Box>
              <Button variant="contained" onClick={checkOpenApi} disabled={specStatus === 'loading'}>
                Check OpenAPI
              </Button>
            </Box>
            {specStatus === 'ok' ? <Alert severity="success">OpenAPI spec reachable.</Alert> : null}
            {specStatus === 'error' ? <Alert severity="error">{specError}</Alert> : null}
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default DashboardPage;

